import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const useApiClientsStore = defineStore('apiClients', {
  state: () => ({
    apiClients: []
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/api_clients')
        .then(response => {
          this.apiClients = response.data.api_clients
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async destroy(apiClientId) {
      return httpClient.delete(`/api/internal/api_clients/${apiClientId}`)
        .then(() => {
          this.apiClients = this.apiClients.filter(apiClient => apiClient.id !== apiClientId)
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    }
  }
})
